/**
 * Calisan bundle'in urun surumu. Tek kaynak: build zamaninda Vite'in gomdugu
 * VITE_APP_VERSION (Dockerfile ARG APP_VERSION <- scripts/compute-version.sh).
 *
 * Ayni string backend'de BeetegreVersion.Current olarak okunur, yani bir deploy'un
 * iki yarisi Sentry'de tek release adi altinda toplanir ve UI'daki surum etiketi
 * ile /health yaniti birbirini tutar.
 *
 * Lokal `npm run dev` icin deger tanimsizdir; o durumda LOCAL_VERSION dondurulur.
 */
const LOCAL_VERSION = 'dev';

export const APP_VERSION: string =
  (import.meta.env.VITE_APP_VERSION as string | undefined) ?? LOCAL_VERSION;
